var _path, _path2, _path3, _g, _path4, _path5, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUfo22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 778,
    viewBox: "0 0 574 778",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M338.074 458.676C393.551 452.885 445.118 461.428 483.627 479.816C522.172 498.221 547.332 526.311 550.799 559.521C554.265 592.73 535.449 625.41 501.536 651.379C467.654 677.323 418.963 696.332 363.486 702.123C308.009 707.914 256.441 699.371 217.931 680.983C179.387 662.578 154.228 634.488 150.761 601.279C147.295 568.07 166.11 535.389 200.023 509.42C233.904 483.475 282.597 464.467 338.074 458.676Z",
    fill: "url(#paint0_radial_1794_3852)",
    stroke: "#00FF26",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.395 92.0757C331.888 74.8616 312.501 61.1641 290.882 59.0636C255.119 55.5889 221.77 82.3493 217.132 117.706C239.146 111.623 264.125 105.073 285.49 100.81C303.968 97.1229 324.282 94.9343 342.395 92.0757Z",
    fill: "url(#paint1_linear_1794_3852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.688 61.0542C310.541 62.9831 328.529 75.0467 339.045 90.5691C321.835 93.186 302.576 95.3614 285.098 98.8489C264.621 102.935 240.863 109.108 219.585 114.956C225.526 82.167 257.026 57.7838 290.688 61.0542Z",
    stroke: "url(#paint2_linear_1794_3852)",
    strokeOpacity: 0.54,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1794_3852)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.459 184.696C366.903 171.238 435.055 119.409 430.267 95.4122C425.479 71.4155 347.86 81.8178 280.415 95.2757C212.97 108.733 125.752 135.542 130.541 159.538C135.329 183.535 232.014 198.154 299.459 184.696ZM328.41 145.104C329.606 151.084 313.504 159.344 292.445 163.553C271.387 167.763 253.347 166.329 252.152 160.349C250.957 154.37 267.058 146.11 288.117 141.9C309.175 137.69 327.215 139.125 328.41 145.104Z",
    fill: "url(#paint3_radial_1794_3852)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.708 96.7467C314.416 90.0208 350.59 84.0751 378.904 82.7972C393.077 82.1576 405.167 82.6944 413.963 84.8327C422.854 86.9944 427.783 90.6268 428.796 95.7058C429.318 98.32 428.868 101.443 427.4 105.016C425.934 108.583 423.49 112.505 420.162 116.656C413.507 124.957 403.447 134.014 391.083 142.783C366.356 160.321 332.648 176.544 299.165 183.225C265.643 189.914 224.789 189.63 191.726 184.679C175.193 182.203 160.685 178.571 150.051 174.102C144.732 171.867 140.442 169.448 137.362 166.904C134.272 164.353 132.517 161.778 132.012 159.245C131.513 156.747 132.178 154.107 134.083 151.278C136.002 148.43 139.121 145.484 143.324 142.488C151.728 136.499 164.15 130.531 178.928 124.855C208.458 113.512 247.034 103.466 280.708 96.7467ZM287.822 140.429C277.197 142.553 267.767 145.709 261.104 149.127C257.783 150.831 255.069 152.64 253.242 154.479C251.461 156.271 250.232 158.398 250.681 160.644C251.13 162.889 253.082 164.38 255.415 165.349C257.809 166.344 261.009 166.972 264.731 167.268C272.196 167.861 282.115 167.148 292.74 165.024C303.365 162.9 312.795 159.745 319.458 156.327C322.78 154.623 325.493 152.813 327.32 150.975C329.102 149.182 330.33 147.055 329.881 144.81C329.432 142.564 327.48 141.074 325.147 140.104C322.754 139.109 319.553 138.482 315.831 138.186C308.366 137.592 298.447 138.304 287.822 140.429Z",
    stroke: "url(#paint4_linear_1794_3852)",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M262.425 159.606C278.652 149.024 297.998 144.279 317.28 146.152L320.057 146.422L457.455 572.343L452.855 580.521C410.981 654.96 308.425 666.37 251.214 602.954L262.425 159.606Z",
    fill: "#005B0F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_1794_3852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.341 154.084C279.842 146.978 291.681 143.73 303.478 144.993L311.357 145.837L420.2 538.966C424.835 555.709 417.523 573.464 402.441 582.087L397.206 585.08C368.868 601.281 335.085 605.023 303.889 595.416C289.912 591.112 280.256 578.349 279.915 563.729L270.341 154.084Z",
    fill: "#1DAD35"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    filter: "url(#filter2_f_1794_3852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.81 150.292C286.081 146.816 291.564 145.193 297.039 145.784L300.245 146.13L380.594 501.289C366.72 532.282 323.493 534.321 306.765 504.771L306.11 503.615L281.81 150.292Z",
    fill: "#5BE472"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1794_3852",
    x: 130.352,
    y: 81.044,
    width: 300.154,
    height: 112.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1794_3852"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1794_3852",
    x: 261.441,
    y: 135.826,
    width: 169.04,
    height: 473.717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.45,
    result: "effect1_foregroundBlur_1794_3852"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1794_3852",
    x: 272.91,
    y: 136.765,
    width: 116.584,
    height: 397.916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.45,
    result: "effect1_foregroundBlur_1794_3852"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1794_3852",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(350.78 580.399) rotate(84.0407) scale(124.385 203.105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275629,
    stopColor: "#3CAB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1794_3852",
    x1: 268.551,
    y1: 72.4555,
    x2: 280.921,
    y2: 118.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A445A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A92C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1794_3852",
    x1: 241.182,
    y1: 47.6065,
    x2: 278.94,
    y2: 104.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1794_3852",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.694 153.082) rotate(-10.1173) scale(137.235 57.546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A7DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1794_3852",
    x1: 273.023,
    y1: 80.5604,
    x2: 293.076,
    y2: 152.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54FF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo22);
export default __webpack_public_path__ + "static/media/ufo22.1fe5491ce003c6ba40eed556be16f7ff.svg";
export { ForwardRef as ReactComponent };